export default "__VITE_ASSET__CnEVeri9__"